const TOKEN_STORAGE_KEY = 'cmine.token';

/** Lit le JWT stocké dans le localStorage (null si absent). */
export function getStoredToken(): string | null {
  return localStorage.getItem(TOKEN_STORAGE_KEY);
}

/** Stocke le JWT dans le localStorage. */
export function setStoredToken(token: string): void {
  localStorage.setItem(TOKEN_STORAGE_KEY, token);
}

/** Supprime le JWT du localStorage. */
export function clearStoredToken(): void {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
}

/**
 * Décode le subject (login) du JWT stocké, sans vérification de signature
 * (la validation est faite côté serveur). Retourne null si absent/invalide.
 */
export function getStoredLogin(): string | null {
  const token = getStoredToken();
  if (!token) {
    return null;
  }
  try {
    const payload = token.split('.')[1] ?? '';
    const decoded = JSON.parse(atob(payload)) as { sub?: string };
    return decoded.sub ?? null;
  } catch {
    return null;
  }
}
